import overlayManager from 'managers/overlay';
import WCCVideo from 'models/attachments/video';

components.preload('video-overlay-stage');

export class VideoOverlayManager {
    constructor() { }

    async show(video: WCCVideo) {
        return await overlayManager.toOverlay('<video-overlay-stage params="model: $data"></video-overlay-stage>', {
            data: video,
            buttons: ['close']
        });
    }
}

const videoOverlayManager = new VideoOverlayManager();

export default videoOverlayManager;